export enum QueryParamName {
        STEP_KEY = 'stepKey',
        PROCESS_ID = 'processId',
        SESSION_ID = 'sessionId',
        OFFER_ID = 'offerId',
        PARTNER = 'partner',
        SOURCE = 'source',
        TEST = 'test',
        ORIGIN = 'origin',
        LOGGED_USER_ID = 'loggedUserId',
        OPEN_AZTEC_SCANNER = 'openAztecScanner',
        PARTNER_EXTERNAL_ID = 'partnerExternalId',
        AZTEC_ENCODED = 'aztecEncoded',
        SKIP_TO_STEP = 'skipToStep',
        USER_PAYLOAD = 'user_payload',
        SESSION_STAGE = 'sessionStage',
        CONTEXT = 'context',
        PARTNER_ID = 'partnerId',
        USER_ID = 'userId',
        DEVICE_SERIAL_NUMBER = 'deviceSerialNumber',
        LOGO_REDIRECT_DISABLED = 'logoRedirectDisabled',
        APPLICATION_ID = 'applicationId',
        TESTING_PRESETS = 'testingPresets',
        CONTEXT_ID = 'contextId',

        // calculation params
        IS_GAS_INSTALLATION = 'isGasInstallation',
        IS_ABROAD = 'isAbroad',
        VEHICLE_CONDITION = 'vehicleCondition', // YANOSIK
        CONDITION = 'condition', // OLX
        YOUNGEST_DRIVER_AGE = 'youngestDriverAge',
        EMAIL = 'email',
        PHONE_NUMBER = 'phoneNumber',
        MAKE = 'make', // brand name
        BRAND_NAME = 'brandName',
        YEAR = 'year', // production year
        ACTUAL_MILEAGE = 'actualMileage',
        VIN = 'vin',
        MODEL = 'model',
        FUEL = 'fuel',
        REGISTRATION_NUMBER = 'registrationNumber',
        FIRST_NAME = 'firstName',
        LAST_NAME = 'lastName',
        POSTAL_CODE = 'postalCode',
        PESEL = 'pesel',
        CITY = 'city',
        STREET = 'street',
        BUILDING_NUMBER = 'buildingNumber',
        FLAT_NUMBER = 'flatNumber',
}
